import KeycloakService from '@/security/KeycloakService.js'

// Autorização de tela (TRI-107). A rota é a fonte única de quem pode abrir a tela:
//
// - `meta.roles`: lista de roles do realm; basta ter uma delas. Pode ser uma função `(rota) => roles`
//   quando a mesma rota atende telas diferentes pelo parâmetro (ex.: /monitoramentos/:monitoramentoUrl).
// - Sem `meta.roles` (ou com a lista vazia), a tela abre para qualquer usuário autenticado.
// - O admin passa em toda rota, como no restante do front. `meta.semAdmin: true` tira esse bypass,
//   para dado sensível em que a API também não deixa o admin passar (ex.: RH, só peopleCulture).
//
// O guard global em @/router/index.js aplica isto em toda navegação, e o menu lateral usa a mesma
// função para decidir o que mostrar — por isso menu e URL digitada não divergem mais.
// As roles daqui só escondem a tela; quem protege o dado é a API, que precisa exigir as mesmas.

export function rolesDaRota(rota) {
  const roles = rota?.meta?.roles

  return typeof roles === 'function' ? roles(rota) : roles
}

export function podeAcessarRota(rota) {
  const roles = rolesDaRota(rota)

  if (!roles || roles.length === 0) return true

  // IsGranted devolve undefined antes de o Keycloak carregar o token; aqui isso conta como "não".
  if (KeycloakService.IsGranted(roles) === true) return true

  return !rota.meta.semAdmin && KeycloakService.IsGranted('admin') === true
}

export function guardaDeRoles(to) {
  return podeAcessarRota(to) ? true : { name: 'forbiddenPage' }
}
